/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DataService_Models_SurveyMode {
    PORTAL = 'portal',
    OLA = 'ola',
    QUALMM = 'qualmm',
    ENGAGE = 'engage',
    REGISTER = 'register',
}
